import React, {useState} from 'react'

import * as S from './styled'
import {images} from "./image";
import Carousel from "./Carousel";
import Sections from "./Sections";

const list = [
    {
        title: 'TRIATHLON, AQUATLHON E DUATHLON',
        slug: 'triathlon'
    },
    {
        title: 'CORRIDA',
        slug: 'corrida'
    },
    {
        title: 'CICLISMO',
        slug: 'ciclismo'
    },
    {
        title: 'NATAÇÃO',
        slug: 'natacao'
    },
    {
        title: 'MUSUCULAÇÃO INDIVIDUALIZADA',
        slug: 'musculacao'
    },
    {
        title: 'COACHING',
        slug: 'coaching'
    },
    {
        title: 'PALESTRAS',
        slug: 'palestras'
    },
]

const ModalityComponent = () => {
    const [hidden, setHidden] = useState(false);
    const [activeImage, setActiveImage] = useState('');
    const [modality, setModality] = useState('triathlon');

    function getCoords(elem) {
        let box = elem.getBoundingClientRect();

        return {
            top: box.top + window.pageYOffset,
            right: box.right + window.pageXOffset,
            bottom: box.bottom + window.pageYOffset,
            left: box.left + window.pageXOffset
        };
    }

    const handleModality = (slug: string) => {
        if (window.innerWidth <= 768) {
            let page = document.createElement('body');
            const element = document.getElementById(`${slug}`);
            let coords = getCoords(element);

            scrollTo(0, coords.bottom - 600)

            // @ts-ignore
            // element.scrollIntoView({behavior: 'smooth'}, true);
        }

        setModality(slug);
    }

    const getModality = (type) => {
        let modality = {
            'triathlon': '<p>Você tem duas treinadoras especialistas em triathlon, com vasta experiência em provas de todas as distâncias que vão te levar para um nível altamente diferenciado. Sua planilha estará de acordo com sua rotina de vida propiciando um melhor aproveitamento de seu tempo disponível para treinar. <br /><br />Se você nunca treinou triathlon, não tem bicicleta e é totalmente inexperiente pode iniciar com treinos indoor e gradativamente passará a treinos outdoor. <br /><br />Se você já tem treinamento, prepare-se para ter resultados nunca imaginados. <br /><br />Venha fazer parte deste time! </p>',
            'corrida': '<p>As quartas e sextas os treinos acontecem sempre no Kartódromo que fica no Parque Taquaral. <br /><br /> A primeira parte do treino fazemos um trabalho técnico específico da corrida com exercícios educativos, agilidade e coordenação. Depois cada aluno executa o treino que está prescrito para o dia e fechamos com um trabalho de mobilidade e alongamento. <br /><br /> Aos domingo realizamos os treinos longos que são realizados com toda comodidade na Padoca do Vila revezando entre a unidade Taquaral e Joaquim Egídio. <br /><br /> Venha decolar com a gente!</p>',
            'ciclismo': '<p>Os treinos as terças e quintas acontecem cedinho na Avenida Mackenzie. <br /><br /> Nós dividimos em duas turmas de acordo com o condicionamento de cada aluno. Os atleta de nível mais avançado treina com o Rodrigo Dirani (1h30 de treino) e os atletas de Nível intermediário ou iniciante treina com a Lilian Pedroso (1h00 de treino) <br /><br /> Aos Sábados realizamos os treinos longos na estrada com um suporte completo com: Hidratação, Acompanhamento com carro, Mecânico de bicicleta pra qualquer intercorrência com seu equipamento e Orientação do treinador no carro e/ou bicicleta e/ou moto. <br /><br /> Acelere com a RM!</p>',
            'natacao': '<p>Os treinos acontecem na piscina da academia Companhia Athletica Campinas (Shopping Galleria), que temos parceria nos planos Semestral e Anual com 35% de desconto. <br /><br /> Todas as terças e quintas feiras à noite atendemos duas turmas de treino das 17h às 19h. <br /><br /> Trabalhamos com 3 raias divididas por performance de cada grupo de atletas com o comando da experiente Rosana Merino na borda da piscina. <br /><br /> Venha treinar com quem realmente entende do assunto! </p>',
            'musculacao': '<p>Você receberá uma planilha de treinos de força feita especialmente para o seu perfil, considerando sua modalidade, objetivos e rotina.  <br /><br /> Ela será ajustada continuamente para desenvolver resistência, potência, hipertrofia, definição muscular e prevenir lesões, sempre em equilíbrio com os treinos técnicos. <br /><br /> Tudo isso direto no TrainingPeaks,  juntamente com os seus treinos gerais, sem a necessidade de ter um novo aplicativo. Facilitando assim o seu controle de carga diária de treino.</p>',
            'coaching': 'A Rosana Merino é pós-graduada em Coaching pelo IBC, trabalhou durante dois anos com Coaching Esportivo e atualmente usa como ferramenta para elevar seus atletas a um nível elevado. <br /><br /> O trabalho mental é um diferencial que a treinadora ensina a seus atletas devido a vasta experiência que tem nesta área.</p>',
            'palestras': '<p>Rosana Merino além de treinadora, faz palestra motivacionais para muitas empresas levando o time a mudar o Mindset e apresentar o seu melhor resultado. <br /><br /> Algumas em Empresas que trabalhamos: Unimed, GM Internacional, Itaú, Unifaj, Unimax, Nortel, Mônaco Investimentos e outras.</p>',
        };
        return modality[type];
    }

    const openModal = (image: string) => {
        setActiveImage(image)
        setHidden(true)
    }

    return (
        <S.Wrapper id="modalidades">
            <S.InternalWrapper>
                <S.Title>Modalidades</S.Title>
                <S.Content>
                    <S.ContainerLinks>
                        <ul>
                            {list.map((item, index) => {
                                return (
                                    <div key={index}>
                                        <S.Links
                                            onClick={() => handleModality(item.slug)}
                                            active={item.slug === modality ?? true}
                                            id={item.slug}
                                        >
                                            {item.title}
                                        </S.Links>
                                        <Sections active={item.slug === modality ?? true}
                                                  text={getModality(modality)}/>
                                    </div>
                                )
                            })}
                        </ul>
                    </S.ContainerLinks>
                    <S.Description>
                        <span dangerouslySetInnerHTML={{__html: getModality(modality)}}/>
                    </S.Description>
                </S.Content>
                <S.ContentImages>
                    <S.BoxImage modal={hidden} image={activeImage} onClick={() => setHidden(false)}/>
                    <Carousel images={images} openModal={openModal}/>
                </S.ContentImages>
            </S.InternalWrapper>
        </S.Wrapper>
    );
};

export default ModalityComponent;
